import { CartAddEvent, CartUpdateEvent } from '@theme/events';

(function () {
  const loader = document.querySelector('.cart-loader');

  document.addEventListener('change', onVariantChange);

  function onVariantChange(event) {
    const select = event.target.closest('.line-item-option');
    if (!select) return;

    showLoader();

    const option = select.options[select.selectedIndex];
    if (!option) {
      hideLoader();
      return;
    }

    const variantData = getVariantData(option);
    if (!variantData) {
      hideLoader();
      return;
    }

    swapVariant(variantData);
  }

  function getVariantData(option) {
    const newVariantId = option.dataset.variantId;
    const oldVariantId = option.dataset.oldVariantId;
    const quantity = Number(option.dataset.itemQuantity) || 1;

    if (!newVariantId || !oldVariantId || newVariantId === oldVariantId) {
      return null;
    }

    return { newVariantId, oldVariantId, quantity };
  }

  async function swapVariant({ oldVariantId, newVariantId, quantity }) {
    try {
      await addVariant(newVariantId, quantity);
      await removeVariant(oldVariantId);
      notifyTheme();
    } catch (err) {
      console.error('Variant switch error:', err);
    } finally {
      hideLoader();
    }
  }

  function removeVariant(variantId) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 0 })
    }).then(validateResponse);
  }

  function addVariant(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    }).then(validateResponse);
  }

  function notifyTheme() {
    document.dispatchEvent(
      new CartUpdateEvent({}, 'variant-swap', {
        source: 'cart-items-component'
      })
    );
  }

  function validateResponse(res) {
    if (!res.ok) throw new Error('Cart request failed');
    return res;
  }

  function showLoader() {
    if (loader) loader.classList.remove('hidden');
  }

  function hideLoader() {
    if (loader) loader.classList.add('hidden');
  }
})();
